import type { RouteType } from 'common/types/route';
import { DCR_DASHBOARD_PERMISSIONS, DCR_DASHBOARD_ROLES } from 'common/utils/dcrConstants';
import { lazy } from 'react';

export let routes: RouteType[] = [
    {
        component: lazy(() => import('module/dcrDashboard/DcrDashboardPage')),
        permissions: DCR_DASHBOARD_PERMISSIONS,
        role: DCR_DASHBOARD_ROLES,
        path: '/dcrDashboard',
        studyOnlyRequired: true,
    },
];
